import { ErrorView } from "@/components/ErrorView";
import { Loader2 } from "lucide-react";

export function LoadingIndicator({ message = "Loading…" }: { message?: string }) {
  return (
    <div className="flex flex-1 items-center justify-center text-muted-foreground gap-2">
      <Loader2 className="size-4 animate-spin" /> {message}
    </div>
  );
}

// Page-level error — fills the available content area inside DashboardLayout.
// Use this when a top-level query for a route fails.
export function ErrorComponent({ error }: { error: unknown }) {
  return <ErrorView variant="page" error={error} />;
}

// Inline error — sits inside a section, form, or dialog. Compact and copyable.
// Pass onRetry for a failed load so the reader has a next step.
export function InlineError({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  return <ErrorView variant="inline" error={error} onRetry={onRetry} />;
}
